import { render, staticRenderFns } from "./StudentEditTabSocialLinks.vue?vue&type=template&id=1cf4d2d5&scoped=true&"
import script from "./StudentEditTabSocialLinks.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabSocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabSocialLinks.vue?vue&type=style&index=0&id=1cf4d2d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4d2d5",
  null
  
)

export default component.exports